"use client"

import * as React from "react"
import { Calendar, CloudSun, Calculator, StickyNote, Puzzle } from "lucide-react"

interface WidgetIconProps {
  id?: string
  icon?: string
  name?: string
  className?: string
  size?: number | string
}

export function WidgetIcon({ id, icon, name = "Widget", className = "size-4.5 text-zinc-800 dark:text-zinc-100", size }: WidgetIconProps) {
  // Map system widgets to standard Lucide icons
  if (id === "system-calendar" || icon === "📅" || name.toLowerCase().includes("calendário")) {
    return <Calendar className={className} style={size ? { width: size, height: size } : undefined} />
  }
  if (id === "system-weather" || icon === "☁️" || name.toLowerCase().includes("clima")) {
    return <CloudSun className={className} style={size ? { width: size, height: size } : undefined} />
  }
  if (id === "system-calculator" || icon === "🧮" || name.toLowerCase().includes("calculadora")) {
    return <Calculator className={className} style={size ? { width: size, height: size } : undefined} />
  }
  if (id === "system-notes" || icon === "📝" || name.toLowerCase().includes("notas") || name.toLowerCase().includes("bloco")) {
    return <StickyNote className={className} style={size ? { width: size, height: size } : undefined} />
  }

  // Fallback to Puzzle icon for all other custom widgets
  return <Puzzle className={className} style={size ? { width: size, height: size } : undefined} />
}
